<template>
  <panel-main-template>
    <template v-slot:page-title>Отчеты</template>
    <template v-slot:page-content>
      <div class="stat--container">
        <div class="stat--tabs">
          <ul class="tabs-container shadow-card">
            <li
                @click="clickTab(item)"
                v-bind:class="{ active: item.isActive }"
                v-for="item in tabs"
                :key="item.id"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>

        <div class="stat--period">
          <div class="block shadow-card">
            <div><b>Выберите период</b></div>
            <div class="row mrg-t-10">
              <div class="input-block">
                <label>Дата от</label>
                <date-picker v-model="periodDateFrom"></date-picker>
              </div>
              <div class="input-block">
                <label>Дата до</label>
                <date-picker v-model="periodDateTo"></date-picker>
              </div>
            </div>
            <div class="hint">
              Максимальный период - 6 месяцев
            </div>
          </div>
          <div v-if="isSelectedPeriod && activeTabIndex == 1" class="block shadow-card">
            <div><b>Период для сравнения</b></div>
            <div class="row mrg-t-10">
              <div class="input-block">
                <label>Дата от</label>
                <date-picker v-model="periodCompareDateFrom"></date-picker>
              </div>
              <div class="input-block">
                <label>Дата до</label>
                <date-picker v-model="periodCompareDateTo"></date-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="stat--components mrg-t-15">
          <div class="stat--main" v-show="activeTabIndex == 1">
            <statistics-main
              :periodDateFrom="periodDateFrom"
              :periodDateTo="periodDateTo"
              :periodCompareDateFrom="periodCompareDateFrom"
              :periodCompareDateTo="periodCompareDateTo"
              :show="activeTabIndex == 1"
            ></statistics-main>
          </div>
          <div class="stat--staff" v-show="activeTabIndex == 2">
            <statistics-staff
              :periodDateFrom="periodDateFrom"
              :periodDateTo="periodDateTo"
              :show="activeTabIndex == 2"
            ></statistics-staff>
          </div>
          <div class="stat--staff" v-show="activeTabIndex == 3">
            <statistics-returnabillity
              :periodDateFrom="periodDateFrom"
              :periodDateTo="periodDateTo"
              :show="activeTabIndex == 3"
            ></statistics-returnabillity>
          </div>
          <div class="stat--staff" v-show="activeTabIndex == 4">
            <statistics-service
              :periodDateFrom="periodDateFrom"
              :periodDateTo="periodDateTo"
              :show="activeTabIndex == 4"
            ></statistics-service>
          </div>
        </div>
      </div>
    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src
import PanelMainTemplate from "../../components/panel/MainTemplate";
import permissionMixin from "@/components/mixins/Permissions";
import StatisticsMain from "@/components/panel/statistics/StatisticsMain";
import StatisticsStaff from "@/components/panel/statistics/StatisticsStaff";
import StatisticsReturnabillity from "@/components/panel/statistics/StatisticsReturnability";
import StatisticsService from "@/components/panel/statistics/StatisticsService";
import DatePicker from '../../components/DatePicker.vue';

export default {
  name: "Statistics",
  components: {
    StatisticsService,
    StatisticsReturnabillity,
    StatisticsStaff,
    StatisticsMain,
    PanelMainTemplate,
    DatePicker
  },
  mixins: [permissionMixin],
  data() {
    return {
      periodDateFrom: '',
      periodDateTo: '',
      periodCompareDateFrom: '',
      periodCompareDateTo: '',
      tabs: [
        {
          id: 1,
          name: "Сводный отчет",
          isActive: true
        },
        {
          id: 2,
          name: "Сотрудники",
          isActive: false
        },
        {
          id: 3,
          name: "Возвращаемость",
          isActive: false
        },
        {
          id: 4,
          name: "Услуги",
          isActive: false
        },
      ],
    };
  },
  watch: {

  },
  computed: {
    activeTabIndex() {
      let result = 0;
      this.tabs.forEach(function(item) {
        if (item.isActive) {
          result = item.id;
        }
      });
      return result;
    },
    isSelectedPeriod(){
      let result = false;
      if(this.periodDateFrom != '' && this.periodDateTo != ''){
        result = true;
      }
      return result;
    },
    isSelectedCompare(){
      let result = false;
      if(this.periodCompareDateFrom != '' && this.periodCompareDateTo != ''){
        result = true;
      }
      return result;
    }
  },
  methods: {
    clickTab(item) {
      for (let key in this.tabs) {
        if (this.tabs[key].id === item.id) {
          this.tabs[key].isActive = true;
        } else {
          this.tabs[key].isActive = false;
        }
      }
    },
  },
  metaInfo: {
    title: "Отчеты - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  created() {
  }
};
</script>

<style scoped lang="less">
  .stat--period{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;

    .block{
      margin-right: 8px;
      //width: 300px;

      .row{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        flex-direction: row;

        &>div{
          margin-right: 5px;
        }
      }
    }
  }

@media (max-width: 600px) {

}
</style>
